import { render, staticRenderFns } from "./DiscoveryBioPanel.vue?vue&type=template&id=5a7e04a5&"
import script from "./DiscoveryBioPanel.vue?vue&type=script&lang=js&"
export * from "./DiscoveryBioPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports